import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexView from '../views/index.vue'
import HomeView from '../views/page.vue'
import BBCView from "../views/BBCView.vue";
import xingyuanView from "../views/xingyuanView.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: IndexView

  },
  {
    path: '/anshu',
    name: 'anshu',
    component: HomeView
  },
  {
    path: '/bbc',
    name: 'bbc',
    component: BBCView
  },
  {
    path: '/xingyuan',
    name: 'xingyuan',
    component: xingyuanView
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
